import type { Option } from '../component/control/option';

export class UiState {
    sidebarToggled: boolean = false;
    assortmentViewModeTable: boolean = false;
    sidebarVisible: boolean = false;
    currentScales: Option = {} as Option;
}
